import { createSelector } from 'reselect'
import {
  ReceiptAttachmentModel,
  ReceiptAttachmentResponse,
} from 'src/models/receiptAttachment.models'
import { RootState } from 'src/redux/createRootReducer'

export const selectReceiptAttachmentsListResponsesFromState = (
  state: RootState,
): Record<string, ReceiptAttachmentResponse> =>
  state.data.receiptAttachments.listResponses

export const selectReceiptAttachmentsListModels = createSelector(
  [selectReceiptAttachmentsListResponsesFromState],
  (receiptAttachments) =>
    Object.values(receiptAttachments).reduce(
      (acc, curr) => ({
        ...acc,
        [curr.id]: new ReceiptAttachmentModel(curr),
      }),
      {} as Record<string, ReceiptAttachmentModel>,
    ),
)

export const selectIsPushingAttachmentsToERPFromState = (
  state: RootState,
): boolean => state.data.receiptAttachments.pushingAttachmentsToERP
